import React, { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Button,
  CircularProgress,
  Box,
  Grid,
  Autocomplete,
  TextField,
  ThemeProvider,
  Card,
  CardContent,
  CardHeader,
  Breadcrumbs,
  Snackbar,
  Alert,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { createTheme, styled } from "@mui/material/styles";
import InsightsIcon from "@mui/icons-material/Insights";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SalesRepForm from "./SalesRepForm";
import salesRepValidationSchema from "./utils/salesRepValidationSchema";
import BaseFormWrapper from "../../components/shared/BaseFormWrapper";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1e5d45", // Custom primary color
    },
  },
});

const StyledHr = styled("hr")(({ theme }) => ({
  border: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
  // margin: theme.spacing(4, 0),
  opacity: 0.8,
}));


function CreateSalesRep() {
  const navigate = useNavigate();
  const location = useLocation();
  const { salesRep } = location.state || {};

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    branch: "QC", // Default value set to QC
    user_create: "admin", // Set to 'admin'
    user_update: "admin", // Set to 'admin'
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (salesRep) {
      setFormData({
        firstname: salesRep.firstname || "",
        lastname: salesRep.lastname || "",
        branch: salesRep.branch || "QC",
        user_create: salesRep.user_create || "admin",
        user_update: salesRep.user_update || "admin",
      });
    }
  }, [salesRep]);

  const handleBackOrCancel = () => {
    navigate("/manage-salesreps")
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await salesRepValidationSchema.validate(formData, {
        abortEarly: false,
      });

      setErrors({});
      setErrorMessage("");
      setIsLoading(true);

      const submitData = {
        salesrep_data: [
          {
            firstname: formData.firstname,
            lastname: formData.lastname,
            branch: formData.branch,
            user_create: formData.user_create,
            user_update: formData.user_update,
          },
        ],
      };

      try {
        const response = await fetch(
          "https://p8k5ocb148.execute-api.ap-southeast-1.amazonaws.com/prod/postSalesRep",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(submitData),
          }
        );

        if (response.ok) {
          setSuccessMessage("Sales Representative created successfully!");
          setTimeout(() => {
            navigate("/manage-salesreps");
          }, 3000);
        } else {
          setErrorMessage(
            "An unexpected error occurred while creating the Sales Representative. Please try again later."
          );
        }
      } catch (error) {
        setErrorMessage(
          `An error occurred while creating the Sales Representative: ${error.message}. Please check your network connection and try again.`
        );
      }
    } catch (validationErrors) {
      if (validationErrors.inner) {
        const formattedErrors = validationErrors.inner.reduce((acc, error) => {
          acc[error.path] = error.message;
          return acc;
        }, {});

        setErrors(formattedErrors);
      } else {
        setErrorMessage(
          validationErrors.message ||
            "Validation failed. Please check your input and try again."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <BaseFormWrapper
      titleIcon={<SupervisorAccountIcon />}
      title="Sales"
      subTitle="Sales Representatives"
      subTitleRoute="/manage-salesreps"
      formTitle="Create Sales Represetative"
      successMessage={successMessage}
      setSuccessMessage={setSuccessMessage}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      isLoading={isLoading}
    >

<SalesRepForm
              initialValues={formData}
              setFormData={setFormData}
              onSubmit={handleSubmit}
              isLoading={isLoading}
              errors={errors}
              successMessage={successMessage}
              setSuccessMessage={setSuccessMessage}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              isCreate={true}
              onCancel={handleBackOrCancel}
            />
    </BaseFormWrapper>


    // <ThemeProvider theme={theme}>
    //   {/* Success Snackbar */}
    //   <Snackbar
    //     open={!!successMessage}
    //     autoHideDuration={3000}
    //     anchorOrigin={{ vertical: "top", horizontal: "center" }}
    //     onClose={() => setSuccessMessage("")} // Clear the success message on close
    //   >
    //     <Alert
    //       severity="success"
    //       sx={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         width: "auto",
    //         maxWidth: "100%",
    //         mx: "auto",
    //       }}
    //     >
    //       {successMessage}
    //     </Alert>
    //   </Snackbar>

    //   {/* Loading Snackbar */}
    //   <Snackbar
    //     open={isLoading}
    //     anchorOrigin={{ vertical: "top", horizontal: "center" }}
    //   >
    //     <Alert
    //       severity="info"
    //       icon={<CircularProgress size={18} />}
    //       sx={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         width: "auto",
    //         maxWidth: "100%",
    //         mx: "auto",
    //       }}
    //     >
    //       Loading, please wait...
    //     </Alert>
    //   </Snackbar>

    //   {/* Error Snackbar */}
    //   <Snackbar
    //     open={!!errorMessage}
    //     anchorOrigin={{ vertical: "top", horizontal: "center" }}
    //     onClose={() => setErrorMessage("")}
    //   >
    //     <Alert
    //       severity="error"
    //       sx={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         width: "auto",
    //         maxWidth: "100%",
    //         mx: "auto",
    //       }}
    //     >
    //       {errorMessage}
    //     </Alert>
    //   </Snackbar>
    //   <Box sx={{ padding: "40px 60px" }}>
    //     <Card
    //       variant="outlined"
    //       style={{
    //         marginTop: "40px",
    //         marginBottom: "40px",
    //         borderRadius: 0,
    //       }}
    //     >
    //       <CardHeader
    //         title={
    //           <Box
    //             display="flex"
    //             alignItems="center"
    //             justifyContent="space-between"
    //           >
    //             <Box display="flex" alignItems="center">
    //               <InsightsIcon
    //                 sx={{
    //                   fontSize: "40px",
    //                   color: "white",
    //                   marginRight: "8px",
    //                 }}
    //               />
    //               <Typography variant="h6">Sales</Typography>
    //             </Box>
    //             <Breadcrumbs
    //               aria-label="breadcrumb"
    //               separator={<NavigateNextIcon fontSize="small" />}
    //               sx={{ color: "white" }}
    //             >
    //               <Typography sx={{ color: "#ffffff99" }}>Sales</Typography>
    //               <Typography
    //                 component={RouterLink}
    //                 to="/manage-salesreps"
    //                 sx={{ color: "#ffffff99", textDecoration: "none" }}
    //               >
    //                 Sales Representatives
    //               </Typography>
    //               <Typography sx={{ color: "#ffffff", textDecoration: "none" }}>
    //                 Create Sales Representative
    //               </Typography>
    //             </Breadcrumbs>
    //           </Box>
    //         }
    //         sx={{
    //           backgroundColor: "#1e5d45",
    //           color: "white",
    //           padding: "16px",
    //         }}
    //       />
    //       <CardContent sx={{ padding: "20px" }}>
    //         <SalesRepForm
    //           initialValues={formData}
    //           setFormData={setFormData}
    //           onSubmit={handleSubmit}
    //           isLoading={isLoading}
    //           errors={errors}
    //           successMessage={successMessage}
    //           setSuccessMessage={setSuccessMessage}
    //           errorMessage={errorMessage}
    //           setErrorMessage={setErrorMessage}
    //           isCreate={true}
    //           onCancel={handleBackOrCancel}
    //         />
    //       </CardContent>
    //     </Card>
    //   </Box>
    // </ThemeProvider>
  );
}

export default CreateSalesRep;
